module.exports = __webpack_public_path__ + "static/media/data.6d9f8369.sqlite";